// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "../styles/Navbar.css";
// import ChatbotComponent from "./ChatbotComponent";

// const Navbar = () => {
//   const [darkMode, setDarkMode] = useState(
//     localStorage.getItem("darkMode") === "true"
//   );

//   useEffect(() => {
//     if (darkMode) {
//       document.body.classList.add("dark-mode");
//     } else {
//       document.body.classList.remove("dark-mode");
//     }
//   }, [darkMode]);

//   const toggleDarkMode = () => {
//     const newMode = !darkMode;
//     setDarkMode(newMode);
//     localStorage.setItem("darkMode", newMode);
//     document.body.classList.toggle("dark-mode", newMode);
//   };

//   return (
//     <nav className="navbar">
//       <div className="logo">
//         <Link to="/">JobsHotSpot</Link>
//       </div>

//       <button className="hamburger">☰</button>

//       <div className="menu">
//         <Link to="/">Home</Link>
//         <Link to="/jobs">Jobs</Link>
//         <Link to="/companies">Companies</Link>
//         <Link to="/postjob">Post Job</Link>
//         <Link to="/dashboard">Dashboard</Link>
//         <Link to="/chatbotcomponent">Chatbot</Link>
//       </div>

//       <div className="actions">
//         <button onClick={toggleDarkMode} className="mode-toggle">
//           {darkMode ? "☀️ Light" : "🌙 Dark"}
//         </button>
//         <Link to="/login" className="login-btn">Login</Link>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;



















import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark-mode");
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">JobsHotSpot</Link>
      </div>

      <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      <div className={`menu ${isOpen ? "active" : ""}`}>
        <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
        <Link to="/jobs" onClick={() => setIsOpen(false)}>Jobs</Link>
        <Link to="/companies" onClick={() => setIsOpen(false)}>Companies</Link>
        <Link to="/resume" onClick={() => setIsOpen(false)}>Resume</Link>
        {/* <Link to="/dashboard" onClick={() => setIsOpen(false)}>Dashboard</Link> */}
      </div>

      <div className="actions">
        <button onClick={toggleDarkMode} className="mode-toggle">
          {darkMode ? "☀️ Light" : "🌙 Dark"}
        </button>
        <Link to="/login" className="login-btn">Login</Link>
      </div>
    </nav>
  );
};

export default Navbar;